import styles from './LanguagePicker.module.css';
import { useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ArrowSimple from "../../assets/ArrowSimple";

export default function LanguagePicker({isLight}) {

    const [languageOpen, setLanguageOpen] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const { lang } = useParams(); // current lang

    const languageToggle = () => {
        setLanguageOpen(!languageOpen);
    };

    const switchLanguage = (newLang) => {
        const newPath = location.pathname.replace(`/${lang}`, `/${newLang}`);
        navigate(newPath);
        setLanguageOpen(false);
    };

    let languageClass = `${styles.languageToggle}`;

  return (
    <div className={`${languageClass} ${languageOpen ? styles.open : null}`}>
        <div onClick={languageToggle}>{lang} <ArrowSimple /></div>
        <ul>
            <li onClick={(e) => switchLanguage("en")}>EN</li>
            <li onClick={(e) => switchLanguage("ko")}>한국어</li>
        </ul>
    </div>

  );
}
